import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiDelete, apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';

import { INews } from '../interfaces/INews';
import { INewsResponse } from '../interfaces/INewsResponse';
import { INewsRequest } from '../interfaces/INewsRequest';

export async function fetchNews(sort?: string, pageNumber?: number): Promise<INewsResponse> {
  const paramsPrefix = sort || pageNumber ? '?' : '';
  const params = sort ? `order=${sort}` : '';
  const page = pageNumber !== undefined ? `page=${pageNumber}` : '';

  return apiGet<INewsResponse>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/news${paramsPrefix}${page}&${params}`,
  );
}

export async function fetchPublishedNews(sort?: string, pageNumber?: number): Promise<INewsResponse> {
  const paramsPrefix = sort || pageNumber ? '?' : '';
  const params = sort ? `order=${sort}` : '';
  const page = pageNumber ? `page=${pageNumber}` : '';

  return apiGet<INewsResponse>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/news/published${paramsPrefix}${page}&${params}`,
  );
}

export async function fetchPublishedAnnounce(): Promise<INewsResponse> {
  return apiGet<INewsResponse>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/news/published?type=ANNOUNCEMENT&order=published,desc;`,
  );
}

export async function fetchAnnounceWithoutAuth(): Promise<INewsResponse> {
  return apiGet<INewsResponse>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE, true)}/news/auth`);
}

export async function addNews(news: INewsRequest): Promise<INews> {
  return apiPost<INews>({ url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/news`, body: news });
}

export async function getSingleNews(id: string): Promise<INews> {
  return apiGet<INews>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/news/${id}`);
}

export async function deleteNews(id: string): Promise<void> {
  return apiDelete(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/news/${id}`);
}

export async function updateNews(id: string, data: INewsRequest): Promise<INews> {
  return apiPut<INews>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/news/${id}`, data);
}

export async function publishNews(id: string): Promise<INewsRequest> {
  return apiPut<INewsRequest>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/news/${id}/published`);
}

export async function expiredNews(id: string): Promise<INewsRequest> {
  return apiPut<INewsRequest>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/news/${id}/expired`);
}

export async function attachmentFile(id: string, data: FormData): Promise<INewsRequest> {
  return apiPost<INewsRequest>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/news/${id}/attachment`,
    body: data,
  });
}

export async function deleteFile(newsId: string, id: number): Promise<void> {
  return apiDelete(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/news/${newsId}/attachment?attachmentId=${id}`);
}

export async function getAttachmentNews(newsId: string, fileId: number): Promise<string> {
  return apiGet<string>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/news/${newsId}/attachment?attachmentId=${fileId}`,
  );
}
